import { useEffect } from 'react';
import { useRouter } from 'next/router';

import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useIsGroup from '@/utils/hooks/user/useIsGroup';

import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';
// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Lib
import { CAMPAIGNS_QUERY_ACTION_PARAM } from '@/lib/albums/queryParams';

import type { ModalProps } from '@/components/base/Modal';
// Components
import AlbumFunnelModal from '@/components/pages/albums/AlbumFunnelModal';

type AlbumsPageWrapperProps = {
    children: (args: { toggleAlbumFunnel: ModalProps['onDismiss'] }) => React.ReactNode;
    variant?: 'single' | 'group';
};

const AlbumsPageWrapper = ({ children, variant = 'single' }: AlbumsPageWrapperProps) => {
    const { isOpen: isOpenAlbumFunnel, toggle } = useToggle();
    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeGroup } = useActiveGroup();
    const isGroup = useIsGroup();

    const router = useRouter();
    const queryAction = router.query[CAMPAIGNS_QUERY_ACTION_PARAM.NAME];
    const { deleteQuery } = useRouterQuery();

    const toggleAlbumFunnel = () => {
        if (!activeSocialProfile && !activeGroup) return;

        toggle();
    };

    useEffect(() => {
        if (queryAction === CAMPAIGNS_QUERY_ACTION_PARAM.VALUES.TRACK_CAMPAIGN) {
            toggleAlbumFunnel();
            const newUrl = deleteQuery(CAMPAIGNS_QUERY_ACTION_PARAM.NAME);
            router.replace(newUrl);
        }
    }, [queryAction]);

    return (
        <>
            {children({ toggleAlbumFunnel })}
            <AlbumFunnelModal
                isOpen={isOpenAlbumFunnel}
                toggle={toggleAlbumFunnel}
                variant={variant}
            />
        </>
    );
};

export default AlbumsPageWrapper;
